/**
 * @generated SignedSource<<4dd6ce389e9df69cd15219c8819455ec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoSubjectIcon = "connect" | "iot_radio" | "issue" | "org";
import { FragmentRefs } from "relay-runtime";
export type TodoSubjectIcon_TodoSubject$data = {
  readonly icon: TodoSubjectIcon | null;
  readonly iconUri: string | null;
  readonly " $fragmentType": "TodoSubjectIcon_TodoSubject";
};
export type TodoSubjectIcon_TodoSubject$key = {
  readonly " $data"?: TodoSubjectIcon_TodoSubject$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoSubjectIcon_TodoSubject">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoSubjectIcon_TodoSubject",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "iconUri",
      "storageKey": null
    }
  ],
  "type": "TodoSubject",
  "abstractKey": null
};

(node as any).hash = "081bb668c4665ff741d6403a0ff7e3fa";

export default node;
